export const PRECISION = 3;
export const MAX_GUESSES = 9;
